export default "__VITE_ASSET__$L2E7or4__"